import { render, staticRenderFns } from "./square-image.vue?vue&type=template&id=30600285"
import script from "./square-image.vue?vue&type=script&lang=js"
export * from "./square-image.vue?vue&type=script&lang=js"
import style0 from "./square-image.vue?vue&type=style&index=0&id=30600285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports